module.exports = __webpack_public_path__ + "static/media/parceiro-premed.fb9abbbe.png";